<template>
  <div id="ecommerce-carousel" class="ecommerce-carousel donate-carousel" v-if="products">
    <VueSlickCarousel v-bind="settings">
      <div v-for="product of products" :key="product.id" class="product-slide">
        <a :href="product.url">
          <div class="product-card">
            <div class="product-image" :style="'background-image: url('+ product.image +')'"></div>
            <p class="product-label">{{ product.name }} <span class="card-arrow"><i class="fas fa-chevron-right"></i></span></p>
          </div>
        </a>
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  name: "EcommerceCarousel",
  components: {
    VueSlickCarousel,
  },

  props: {
    productType: {
      type: String,
      validator: (value) => ['adoption', 'wildcard'].includes(value) || !value,
    },
  },
  data() {
    return {
      products: null,
      settings: {
        "infinite": true,
        "slidesToShow": 4,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "arrows": false
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 1,
              "centerMode": true,
              "arrows": false
            }
          },
        ]
      },
    };
  },

  async created() {
    const data = await this.$store.dispatch('getAllEcommerceProducts');

    if (this.productType == 'adoption') {
      this.products = data.filter(x => x.type === 'adoption');
      return;
    }
    if (this.productType == 'wildcard') {
      this.products = data.filter(x => x.type === 'wildcard');
      return;
    }
    this.products = data;
  },
};
</script>

<style scoped>
.product-slide {
  padding: 10px 10px 24px;
}
.product-card {
  box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 6%)
}
.product-image {
  padding-top: 63%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.product-label {
  padding: 0.8rem;
  background: var(--wwfWhite);
}
.card-arrow {
  float: right;
}

@media only screen and (min-width: 601px) {
  .ecommerce-carousel {
    margin: 0 -10px;
  }
}
</style>


// WEBPACK FOOTER //
// EcommerceCarousel.vue?64df20b1